export default {
  JWT_TOKEN_KEY: 'JWT_TOKEN',
  REFRESH_TOKEN_KEY: 'REFRESH_TOKEN',
};
